export default {
    // Data
    UPLOAD_DATA: 'UPLOAD_DATA',
    // Story
    GENERATE_STORY: 'GENERATE_STORY',
    UPDATE_PROGRESS: 'UPDATE_PROGRESS',//生成进度
    //user
    UPDATE_USER_INFO: 'UPDATE_USER_INFO',
    UPDATE_USER_OPERATION: 'UPDATE_USER_OPERATION',
    UPDATE_CONVERT_TYPE: 'UPDATE_CONVERT_TYPE',
    UPDATE_LOCALE: 'UPDATE_LOCALE',



    //init edit
    SET_PARSED_FILE_DATA: 'SET_PARSED_FILE_DATA',
    SET_SCALE: 'SET_SCALE',

    //before generate
    SET_TASK: 'SET_TASK',


    //time seires
    SET_SEQUENCE: "SET_SEQUENCE",
    SET_REDUNDANT: "SET_REDUNDANT",
    ADD_SEGMENTS_INSIGHTS: "ADD_SEGMENTS_INSIGHTS",

    CHANGE_BTN_STATE: "CHANGE_BTN_STATE",
    ADD_EMPTY_CARD: "ADD_EMPTY_CARD",
    CHANGE_CRAD_LOCATION: "CHANGE_CRAD_LOCATION",
    REMOVE_CARD: "REMOVE_CARD",
    FIX_CARD: "FIX_CARD",
    SET_SELECTED_CARD_INDEX: "SET_SELECTED_CARD_INDEX",


    //recommend list
    SET_SELECTED_RECOMMEND_CARD: "SET_SELECTED_RECOMMEND_CARD",
    REMOVE_RECOMMEND_CARD: "REMOVE_RECOMMEND_CARD",
    ADD_RECOMMEND_LIST: 'ADD_RECOMMEND_LIST',

    //pop insight card
    SET_POP_CARD_START: "SET_POP_CARD_START",
    SET_POP_INSIGHTS: "SET_POP_INSIGHTS",

    SET_TOOLTIP_CONTAINER: 'SET_TOOLTIP_CONTAINER',

    //configure columsn
    SET_CONFIGURE_COLUMNS: 'SET_CONFIGURE_COLUMNS',
    SET_CONFIGURE_TYPE: 'SET_CONFIGURE_TYPE',
    SET_CONFIGURE_TIME: 'SET_CONFIGURE_TIME',
    SET_CONFIGURE_BREAKDOWN: 'SET_CONFIGURE_BREAKDOWN',

    UPDATE_FILEURL_AND_DATA: 'UPDATE_FILEURL_AND_DATA',
    UPDATE_COLUMNS_AND_RANGE: 'UPDATE_COLUMNS_AND_RANGE',

    SET_PROCESS_TIME: 'SET_PROCESS_TIME',
    SET_PROCESS_GRANULARITY: 'SET_PROCESS_GRANULARITY',
    SET_PROCESS_COLUMNS: 'SET_PROCESS_COLUMNS'

}